import type { GuideDefinition, GuideStep } from '../engine';
import { afterCustomerResolved, afterVehicle } from './customerBranch';

const customerSteps: GuideStep[] = [
  {
    id: 'search',
    anchor: 'wo-create.search',
    textKey: 'quote.search',
    onEnter: [{ type: 'navigate', to: '/workorders?new=quote' }, { type: 'focus' }],
    doneWhen: 'woCreate.customerVehicleResolved',
    next: afterCustomerResolved,
  },
  {
    id: 'newVehicle',
    anchor: 'wo-create.newVehicle',
    textKey: 'fields.newVehicle',
    onEnter: [{ type: 'focus' }],
    next: afterVehicle,
  },
  {
    id: 'newPerson',
    anchor: 'wo-create.newPerson',
    textKey: 'fields.newPerson',
    onEnter: [{ type: 'focus' }],
    next: 'leaveCustomer',
  },
  {
    id: 'newCompany',
    anchor: 'wo-create.newCompany',
    textKey: 'fields.newCompany',
    onEnter: [{ type: 'focus' }],
    next: 'leaveCustomer',
  },
  {
    id: 'companyContact',
    anchor: 'wo-create.companyContact',
    textKey: 'fields.companyContact',
    onEnter: [{ type: 'focus' }],
    next: 'leaveCustomer',
  },
  {
    id: 'leaveCustomer',
    anchor: 'wo-create.next',
    textKey: 'quote.leaveCustomer',
    onEnter: [{ type: 'focus' }],
    doneWhen: 'woCreate.stepChanged',
    next: 'service',
  },
];

export const quoteCreateGuide: GuideDefinition = {
  id: 'quote.create',
  titleKey: 'quote.title',
  firstStep: 'search',
  doneTextKey: 'quote.done',
  steps: [
    ...customerSteps,
    {
      id: 'service',
      anchor: 'wo-create.service',
      textKey: 'quote.service',
      onEnter: [{ type: 'focus' }],
      doneWhen: 'woCreate.serviceAdded',
      next: 'leaveServices',
    },
    {
      id: 'leaveServices',
      anchor: 'wo-create.next',
      textKey: 'quote.leaveServices',
      onEnter: [{ type: 'focus' }],
      doneWhen: 'woCreate.stepChanged',
      next: 'validity',
    },
    {
      id: 'validity',
      anchor: 'wo-create.quoteValidity',
      textKey: 'quote.validity',
      onEnter: [{ type: 'focus' }],
      next: 'create',
    },
    {
      id: 'create',
      anchor: 'wo-create.submit',
      textKey: 'quote.create',
      onEnter: [{ type: 'focus' }],
      doneWhen: 'woCreate.created',
    },
  ],
};
